<template>
	<div id="jt_bord_view" class="view">
		<div class="form-bar">
			<el-row>
				<el-col :span="12">
					<div class="title" v-text="data.name"></div>
				</el-col>
				<el-col :span="12" style="text-align:right;">
					<el-form :inline="true">
						<el-form-item label="刷新周期：">
							<el-input-number v-model="num" size="small" controls-position="right" @change="handleChange" :step="10" :min="10" :max="30" style="width:100px"></el-input-number>
							<span style="margin-left:10px; color:#aaa;">(秒)</span>
						</el-form-item>
						<el-form-item>
							<el-button type="info" icon="el-icon-back" @click="$router.back()" circle></el-button>
						</el-form-item>
						<el-form-item>
							<el-button icon="el-icon-full-screen" circle @click="handleFullScreen"></el-button>
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
		</div>

		<el-row class="stat-table" v-loading="loading">
			<el-col :span="12">
				<ul>
					<li>
						<label for>工单：</label>
						<span>{{ data.work_order_code | filterShow }}</span>
					</li>
					<li>
						<label for>良品率：</label>
						<span>{{ data.yield_rate }}</span>
					</li>
					<li>
						<label for>机器状态：</label>
						<span>{{ data.statusText }}</span>
					</li>
					<li>
						<label for>检测状态：</label>
						<span>{{ data.checkStatus }}</span>
					</li>
					<li>
						<label for>开机时间：</label>
						<span>{{ data.startTime }}</span>
					</li>
					<li>
						<label for>剩余时间：</label>
						<span>{{ data.remaining }} 分钟</span>
					</li>
					<li>
						<label for>下一工单：</label>
						<span> {{ result }}</span>
					</li>
				</ul>
			</el-col>
			<el-col :span="12">
				<ul>
					<li v-for="(item, index) in techList" :key="index">
						<label for>{{ item.name }}：</label>
						<span>{{ item.value }}</span>
					</li>
				</ul>
			</el-col>
		</el-row>
		<div class="progress">
			<label>进度：</label>
			<el-progress :text-inside="true" :stroke-width="24" :percentage="progressValue" status="exception" :format="formatProgress"></el-progress>
		</div>

		<el-row>
			<el-col :span="4" align="left"></el-col>
			<el-col :span="18" align="right"></el-col>
		</el-row>
	</div>
</template>

<script>
	import VueRouter, { Route } from 'vue-router'
	import { techInfoRequest } from '@/network/requests/techInfo'
	import { techGroupDetailRequest } from '@/network/requests/techGroup'
	import { jobOrderRequest } from '@/network/requests/jobOrder'
	import jtService from '@/service/jtService'
	import { v5 } from 'uuid'
	import { reduce, values } from 'lodash'
	export default {
		data() {
			return {
				num: 10,
				data: {},
				params: {},
				fullscreen: false,
				techGroupDetails: [],
				techInfo: [],
				loading: false,
				techList: [],
				timer: null,
				result: '',
			}
		},
		filters: {
			filterShow(val) {
				if (val) {
					if (val) {
						return val
					}
					return '--'
				}
			},
		},
		computed: {
			jtId() {
				if (this.data) {
					this.showDE(this.params.jt_id, this.data.work_order_code)
					return this.params.jt_id
				}
				return ''
			},
			/**
			 * 更新进度，避免超出100%。
			 */
			progressValue() {
				var value = this.data.progress
				if (value) {
					if (value > 100) {
						value = 100
					}
				} else {
					value = 0
				}
				return value
			},
		},
		methods: {
			showDE(id, code) {
				var that = this
				jobOrderRequest.queryAll({ jt_id: id }, { code: 1, plan_begin_time: 1, jt_id: 1 }, { plan_begin_time: 1 }).then(res => {
					if (!res) {
						that.result = '----'
					} else {
						res.forEach(function(k, v) {
							if (k['code'] == code) {
								if (v == res.length - 1) {
									that.result = '----'
									that.loading = false
								} else {
									that.result = res[v + 1]['code']
									that.loading = false
								}
							}
						})
					}
				})

				return this.result
			},

			formatProgress(percentage) {
				if (this.data.progress) {
					return `${this.data.progress}%`
				} else {
					return ''
				}
			},
			handleChange(value) {
				console.log(value)
			},
			/**
			 * 全屏事件
			 */
			handleFullScreen() {
				const element = document.getElementById('jt_bord_view')
				// 判断是否已经是全屏
				// 如果是全屏，退出
				if (this.fullscreen) {
					if (document.exitFullscreen) {
						document.exitFullscreen()
					} else if (document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen()
					} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen()
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen()
					}
					console.log('已还原！')
				} else {
					// 否则，进入全屏
					if (element.requestFullscreen) {
						element.requestFullscreen()
					} else if (element.webkitRequestFullScreen) {
						element.webkitRequestFullScreen()
					} else if (element.mozRequestFullScreen) {
						element.mozRequestFullScreen()
					} else if (element.msRequestFullscreen) {
						// IE11
						element.msRequestFullscreen()
					}
					console.log('已全屏！')
				}
				// 改变当前全屏状态
				this.fullscreen = !this.fullscreen
			},
			loadDataWithTimer() {
				this.loadData()
				this.timer = setInterval(() => {
					this.loadData()
				}, this.num * 1000)
			},
			loadData() {
				//获取所有工艺。
				var p1 = techInfoRequest.queryAll()
				var teches = []
				Promise.all([p1]).then(res => {
					teches = res[0]
				})

				jtService.getJTStatus(this.jtId).then(res => {
					this.data = res
					var product = this.data.product
					var techGroup_id = this.data.tech_group_id

					//TODO 这里假如机台没有配置工艺参数组，则从产品中获取工艺参数组。
					if (!techGroup_id) {
						if (product) {
							console.log('product', product)
							if (product.tech_group_id) techGroup_id = product.tech_group_id
						}
					}

					//通过机台关联的工艺参数组，获取工艺参数。
					if (techGroup_id) {
						var teches_array = []
						techGroupDetailRequest
							.queryAll({ tech_group_id: techGroup_id })
							.then(res => {
								res.forEach((v, i) => {
									var techInfo = teches.find(t => t._id.$oid == v.tech_id)
									var techValue = this.data.techs.find(t => t.tech_id == v.tech_id) ?? '--'
									teches_array.push({ ...techInfo, value: techValue.value })
								})
							})
							.finally(() => {
								this.techList = teches_array
								this.loading = false
							})
					} else {
						this.loading = false
					}
				})
			},
		},
		created() {
			this.loading = true
			this.params = this.$route.query
			clearInterval(this.timer)

			this.loadDataWithTimer()

			console.log(this.$route.params.data)
		},
		destroyed() {
			clearInterval(this.timer)
		},
	}
</script>

<style scoped>
	.title {
		font-size: 24px;
		padding-top: 12px;
	}

	.stat-table {
		padding: 0 1rem;
	}
	.stat-table ul {
		margin: 0;
		padding: 0;
	}

	.stat-table ul li {
		list-style: none;
		padding: 3px 5px;
		line-height: 50px;
		margin-bottom: 20px;
		font-size: 22px;
	}

	.stat-table ul li span {
		color: #aaa;
	}

	.progress {
		margin: 20px 0;
		border-top: 1px #eee solid;
		padding: 20px 0;
	}

	.progress label {
		font-size: 12px;
		margin-bottom: 10px;
		display: block;
		color: #aaa;
	}

	.view {
		background-color: #fff;
	}
</style>
